import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Share, X } from "lucide-react";

const KEY = "stjames.installPromptDismissed";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () =>
  window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;

export default function InstallPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(KEY) || 0);
    const recentlyDismissed = Date.now() - dismissedAt < 30 * 24 * 3600 * 1000;
    if (isIOS() && !isStandalone() && !recentlyDismissed) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, String(Date.now()));
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 26 }}
          className="fixed inset-x-3 bottom-3 z-50 safe-bottom"
          data-testid="install-prompt"
        >
          <div className="bg-[#1A2F24] text-[#FAF9F6] border border-[#FAF9F6]/15 p-4 flex items-start gap-3 shadow-2xl">
            <img src="/apple-touch-icon.png" alt="" className="h-11 w-11 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="tracker text-[9px] text-[#FAF9F6]/70">Keep it on your phone</p>
              <p className="font-display text-lg leading-tight mt-0.5">Add StJames to your Home Screen</p>
              <p className="font-body text-xs text-[#FAF9F6]/80 mt-1.5 flex items-center gap-1 flex-wrap">
                Tap <Share className="inline h-3.5 w-3.5" aria-label="Share" /> below, then
                <span className="font-medium text-[#FAF9F6]">“Add to Home Screen”</span>.
              </p>
            </div>
            <button
              type="button"
              onClick={dismiss}
              aria-label="Dismiss"
              data-testid="install-prompt-dismiss"
              className="p-2 -m-2 text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="mx-auto h-3 w-3 -mt-1.5 rotate-45 bg-[#1A2F24] border-r border-b border-[#FAF9F6]/15" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
